console.log("✅ SIYAA WISHLIST LOADED");




console.log('✅ SIYAA siyaa-wishlist.js chargé');

(function () {
  const KEY = 'siyaa_wishlist';

  // =========================
  // Utils storage
  // =========================
  function readList() {
  try {
    const raw = localStorage.getItem(KEY);
    const arr = raw ? JSON.parse(raw) : [];
    // ✅ Nettoyage: on garde uniquement des handles valides
    const clean = Array.isArray(arr)
      ? arr
          .filter((x) => typeof x === 'string')
          .map((x) => x.trim())
          .filter((x) => x.length > 0 && !x.includes('/'))
      : [];
    return clean;
  } catch (e) {
    return [];
  }
}


  function writeList(arr) {
    localStorage.setItem(KEY, JSON.stringify(arr));
    document.dispatchEvent(new Event('siyaa:wishlist:update'));
  }

  function has(handle) {
    return readList().includes(handle);
  }

  function toggle(handle) {
    if (!handle) return false;
    const list = readList();
    const i = list.indexOf(handle);
    if (i >= 0) list.splice(i, 1);
    else list.push(handle);
    writeList(list);
    return list.includes(handle);
  }

  function count() {
    return readList().length;
  }

  function getHandleFromURL() {
    const m = location.pathname.match(/\/products\/([^\/\?]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  // =========================
  // Header heart: pulse only if > 0 (NO badge, NO reposition)
  // =========================
  function updateHeaderHeart() {
    const el =
      document.querySelector('[class*="header-wishlist-"]') ||
      document.querySelector('a[href="/pages/wishlist"], a[href*="/pages/wishlist"]') ||
      document.querySelector('a[href*="wishlist"]');

    if (!el) return;

    el.classList.toggle('siyaa-wish-has-items', count() > 0);

    // IMPORTANT: on ne change pas la place, on ne change pas le HTML, juste une classe.
    // On ne remplit pas le coeur du header ici (tu veux garder ton style).
  }

  // =========================
  // Product card hearts (collection / home / featured)
  // Requires your heart button markup on cards:
  // .wishlist-card-btn[data-product-handle]
  // =========================
  function syncCardHearts() {
    document.querySelectorAll('.wishlist-card-btn[data-product-handle]').forEach((btn) => {
      const h = btn.getAttribute('data-product-handle');
      if (!h) return;

      const added = has(h);
      btn.classList.toggle('is-added', added);
      btn.setAttribute('aria-pressed', added ? 'true' : 'false');

      const path = btn.querySelector('path');
      if (path) path.style.fill = added ? '#000' : 'transparent';
    });
  }

  // Click hearts on cards (delegation)
  document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest('.wishlist-card-btn');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const h = btn.getAttribute('data-product-handle');
      const added = toggle(h);

      btn.classList.toggle('is-added', added);
      const path = btn.querySelector('path');
      if (path) path.style.fill = added ? '#000' : 'transparent';

      updateHeaderHeart();
      renderWishlistPageStable(); // refresh if on wishlist page
    },
    true
  );

  // =========================
  // PDP heart (single, centered under price)
  // =========================
  function mountPDPHeart() {
    if (!location.pathname.includes('/products/')) return;

    const handle = getHandleFromURL();
    if (!handle) return;

    // Avoid duplicates
    if (document.querySelector('.siyaa-pdp-wish')) return;

    // Price anchor (best effort)
    const priceEl =
      document.querySelector('product-price') ||
      document.querySelector('[data-testid*="price"]') ||
      document.querySelector('.price') ||
      document.querySelector('.product-price') ||
      document.querySelector('[class*="price"]');

    const addBtn =
      document.querySelector('button[name="add"]') ||
      document.querySelector('product-form button[type="submit"]') ||
      document.querySelector('form[action*="/cart/add"] button[type="submit"]');

    const anchor = priceEl || addBtn;
    if (!anchor) return;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'siyaa-pdp-wish';
    btn.dataset.handle = handle;
    btn.setAttribute('aria-label', 'Ajouter à la wishlist');

    // Heart only (no text)
    btn.innerHTML = `
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5
          2 5.42 4.42 3 7.5 3
          c1.74 0 3.41.81 4.5 2.09
          C13.09 3.81 14.76 3 16.5 3
          19.58 3 22 5.42 22 8.5
          c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
          stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>
      </svg>
    `;

    function paint() {
      const added = has(handle);
      btn.classList.toggle('is-added', added);
      const p = btn.querySelector('path');
      if (p) p.style.fill = added ? '#000' : 'transparent';
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggle(handle);
      paint();
      updateHeaderHeart();
      renderWishlistPageStable();
    });

    // Insert under price if possible, else before add to cart
    if (priceEl) priceEl.insertAdjacentElement('afterend', btn);
    else if (addBtn) addBtn.insertAdjacentElement('beforebegin', btn);
    else anchor.insertAdjacentElement('afterend', btn);

    paint();
  }

  // =========================
  // Wishlist page renderer (stable, no jump)
  // Works with:
  // <div class="wishlist-count"></div>
  // <div id="wishlist-grid"></div>
  // and close button .siyaaWishClose
  // =========================
  let lastSig = null;
  let rendering = false;

  function makeSig(handles) {
    return handles.slice().sort().join('|');
  }

  async function fetchProduct(handle) {
    try {
      const r = await fetch(`/products/${encodeURIComponent(handle)}.js`, { cache: 'no-store' });
      if (!r.ok) return null;
      return await r.json();
    } catch (e) {
      return null;
    }
  }

  async function renderWishlistPageStable() {
    if (!location.pathname.includes('/pages/wishlist')) return;

    const grid = document.getElementById('wishlist-grid') || document.querySelector('.wishlist-grid');
    const countEl = document.querySelector('.wishlist-count');

    if (!grid) return;
    if (rendering) return;
    rendering = true;

    const handles = readList().filter((h) => typeof h === 'string' && h);
    const sig = makeSig(handles);

    // ✅ Toujours mettre à jour le compteur, même si on ne rerender pas
if (countEl) {
  countEl.textContent = handles.length
    ? `${handles.length} article${handles.length > 1 ? 's' : ''}`
    : '0 article';
}

// no rerender if no change
if (sig === lastSig) {
  rendering = false;
  return;
}
lastSig = sig;


    // keep scroll position
    const prevScroll = grid.scrollTop;

    if (countEl) {
      countEl.textContent = handles.length
        ? `${handles.length} article${handles.length > 1 ? 's' : ''}`
        : '';
    }

    if (!handles.length) {
      grid.innerHTML = `<p class="siyaaWishEmpty">Votre wishlist est vide.</p>`;
      grid.scrollTop = 0;
      rendering = false;
      return;
    }

    const fetched = await Promise.all(handles.map(fetchProduct));
const products = fetched.filter(Boolean);

// ✅ Nettoyage automatique: on garde seulement les produits valides
const cleanHandles = products.map(p => p.handle);

// ✅ Si ta wishlist contenait des handles morts -> on met à jour localStorage
if (cleanHandles.length !== handles.length) {
  writeList(cleanHandles);          // met à jour localStorage
  lastSig = null;                   // force le rerender correct
}

// ✅ Compteur basé sur les produits valides (et jamais bloqué)
if (countEl) {
  countEl.textContent = `${cleanHandles.length} article${cleanHandles.length > 1 ? 's' : ''}`;
}

if (!cleanHandles.length) {
  grid.innerHTML = `<p class="siyaaWishEmpty">Votre wishlist est vide.</p>`;
  grid.scrollTop = 0;
  rendering = false;
  return;
}

const html = products
  .map((p) => {
    const img = p.images?.[0] || '';
    const price =
      typeof p.price === 'number' ? (p.price / 100).toFixed(2).replace('.', ',') + ' €' : '';
    const variantId = p.variants?.[0]?.id || '';

    return `
      <div class="siyaaWishRow" data-handle="${p.handle}">
        <a class="siyaaWishImg" href="${p.url}">
          ${img ? `<img loading="lazy" src="${img}" alt="${p.title}">` : ``}
        </a>

        <div class="siyaaWishInfo">
          <a class="siyaaWishTitle" href="${p.url}">${p.title}</a>
          <div class="siyaaWishPrice">${price}</div>

          <div class="siyaaWishRight">
            <button class="siyaaWishLink siyaaWishAdd" type="button" data-add-to-cart="${variantId}">
              Ajouter au panier
            </button>
            <button class="siyaaWishLink siyaaWishRemove" type="button" data-remove="${p.handle}">
              Supprimer
            </button>
          </div>
        </div>
      </div>
    `;
  })
  .join('');

grid.innerHTML = html;


    // restore scroll to prevent jump
    grid.scrollTop = prevScroll;

    rendering = false;
  }

  // Actions inside wishlist page
  document.addEventListener(
    'click',
    function (e) {
      // Close button
      const closeBtn = e.target.closest('.siyaaWishClose');
      if (closeBtn) {
        e.preventDefault();
        e.stopPropagation();
        if (window.history.length > 1) window.history.back();
        else window.location.href = '/';
        return;
      }

      // Remove
      const rem = e.target.closest('[data-remove]');
      if (rem) {
        e.preventDefault();
        e.stopPropagation();
        const h = rem.getAttribute('data-remove');
        if (!h) return;

        const list = readList().filter((x) => x !== h);
        writeList(list);

        syncCardHearts();
        updateHeaderHeart();
        renderWishlistPageStable();
        return;
      }

      // Add to cart + validation discrète
// Add to cart + validation discrète
// Add to cart + validation discrète
const add = e.target.closest('[data-add-to-cart]');
if (add) {
  e.preventDefault();
  e.stopPropagation();

  const id = add.getAttribute('data-add-to-cart');
  if (!id) return;

  const btn = add;
  const originalText = btn.textContent;

  btn.disabled = true;
  btn.style.opacity = '0.5';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: Number(id), quantity: 1 }),
  })
    .then(async (r) => {
      if (!r.ok) throw new Error('add_failed');
      return r.json();
    })
    .then(() => {
      btn.textContent = 'Ajouté ✓';

      setTimeout(() => {
        btn.textContent = originalText || 'Ajouter au panier';
        btn.disabled = false;
        btn.style.opacity = '1';
      }, 1500);
    })
    .catch(() => {
      btn.textContent = originalText || 'Ajouter au panier';
      btn.disabled = false;
      btn.style.opacity = '1';
    });

  return;
}


    },
    true
  );

  // =========================
  // Init (no MutationObserver!)
  // =========================
  function init() {
    mountPDPHeart();
    syncCardHearts();
    updateHeaderHeart();
    renderWishlistPageStable();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('siyaa:wishlist:update', init);
})();




















/* ✅ Fix position coeur wishlist (PC + mobile + tablette) */
(function () {
  function fixWishlistButtons() {
    document.querySelectorAll(".wishlist-card-btn").forEach((btn) => {
      // évite de refaire 1000 fois
      if (btn.dataset.wishFixed === "1") return;
      btn.dataset.wishFixed = "1";

      // parent stable (ton conteneur principal de carte)
      const host =
        btn.closest(".product-card__content.product-grid__card") ||
        btn.closest(".product-grid__card") ||
        btn.closest(".product-card") ||
        btn.parentElement;

      if (!host) return;

      // parent en relative pour que absolute marche
      const hostStyle = getComputedStyle(host);
      if (hostStyle.position === "static") {
        host.style.position = "relative";
      }

      // on s’assure que le bouton reste bien dans ce parent
      if (btn.parentElement !== host) {
        host.prepend(btn);
      }

      // on force la position (comme ton test inline)
      btn.style.position = "absolute";
      btn.style.top = "10px";
      btn.style.right = "10px";
      btn.style.zIndex = "999999";
    });
  }

  function run() {
    // plusieurs passes car Shopify/Atelier rerender
    fixWishlistButtons();
    setTimeout(fixWishlistButtons, 150);
    setTimeout(fixWishlistButtons, 500);
    setTimeout(fixWishlistButtons, 1200);
  }

  document.addEventListener("DOMContentLoaded", run);
  window.addEventListener("resize", run);
  document.addEventListener("shopify:section:load", run);

  // si le DOM bouge après (très fréquent)
  const obs = new MutationObserver(() => {
    // on réautorise le fix sur les nouveaux boutons
    document.querySelectorAll(".wishlist-card-btn").forEach((b) => (b.dataset.wishFixed = ""));
    fixWishlistButtons();
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();









/* ✅ Déplace le coeur uniquement dans la Mise en avant produit */
(function(){
  function moveFeaturedHeart(){
    const section = document.querySelector('.featured-product-section');
    if(!section) return;

    const btn = section.querySelector('.wishlist-card-btn');
    if(!btn) return;

    const media =
      section.querySelector('.cardGallery') ||
      section.querySelector('.card__media') ||
      section.querySelector('.media');

    if(!media) return;

    if (getComputedStyle(media).position === 'static') {
      media.style.position = 'relative';
    }

    // mettre le bouton dans l'image
    if(btn.parentElement !== media){
      media.appendChild(btn);
    }
  }

  const run = () => {
    moveFeaturedHeart();
    setTimeout(moveFeaturedHeart, 200);
    setTimeout(moveFeaturedHeart, 600);
  };

  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
  window.addEventListener('resize', run);

  new MutationObserver(run).observe(document.documentElement, {childList:true, subtree:true});
})();
